import { ApiQueryKey } from '@/configs/ApiQueryKey';
import { Translations } from '@/types/types';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	SELECT = 'SELECT',
	CHIP_SINGLE = 'CHIP_SINGLE',
	OPTION_GRID = 'OPTION_GRID',
	NUMBER = 'NUMBER',
	TEXTAREA = 'TEXTAREA',
}

export interface Attribute extends BaseEntity {
	name: string;
	description?: string;
	functionalId?: string;
	suffix?: string;
	viewType: AttributeViewType;
	listOrder: number;
	isDimension: boolean;
	controlType?: string;
	productTypeId?: string;
	attributeValues?: import('./AttributeValueApi').AttributeValue[];
	translations: Translations<{
		name: string;
		description: string;
		suffix?: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new AttributeApi();
